import _ from './util';

const OPENING_CURLY_REGEX = /^\{/;
const CLOSING_CURLY_REGEX =/\}$/;
const WILD_REGEX = /\{[^\}\.]+\}/g;


function makeData(namedParts, wilds) {
  return _.reduce(namedParts, (result, namedPart, i) => {
    result[namedPart] = wilds[i];
    return result;
  }, {});
}

function makeChange(path, prevValue, value, prevState, state) {
  return {
    prevState,
    state,
    path,
    prevValue,
    value
  };
}

function makeDiffChange(path, prevValue, value, wilds) {
  return {
    path,
    prevValue,
    value,
    wilds
  };
}

function catPath(path, part) {
  return path + (path ? '.' : '') + part;
}

function diffPathParts(value1, value2, parts, path, wilds) {
  if (_.isEmpty(parts)) {
    if (!_.isEqual(value1, value2)) {
      return [makeDiffChange(path, value1, value2, wilds)];
    }
    return [];
  }
  const part = _.first(parts);
  parts = _.slice(parts, 1);
  if (part === '*') {
    let remainingKeys = _.reduce(_.keys(value2), (reduction, key) => _.set(reduction, key, key), _.toMap({}));
    const changes = _.reduce(value1, (reduction, value, key) => {
      remainingKeys = _.delete(remainingKeys, key);
      return reduction.concat(diffPathParts(value, _.get(value2, key), parts, catPath(path, key), wilds.concat([key])));
    }, []);
    return _.reduce(remainingKeys, (reduction, key) => {
      const value = _.get(value2, key);
      return reduction.concat(diffPathParts(_.get(value1, key), value, parts, catPath(path, key), wilds.concat([key])));
    }, changes);
  }
  const selectedValue1 = _.get(value1, part);
  const selectedValue2 = _.get(value2, part);
  if (!_.isEqual(selectedValue1, selectedValue2)) {
    return diffPathParts(selectedValue1, selectedValue2, parts, catPath(path, part), wilds);
  }
  return [];
}

function diffWildIn(value1, value2, path) {
  const parts = _.isString(path) ? path.split('.') : path;
  return diffPathParts(value1, value2, parts, '', []);
}

function matchPatternChanges(change, patternMatcher) {
  const { prevState, state } = change;
  const { parts, namedParts } = patternMatcher;

  const diffChanges = diffWildIn(prevState, state, parts);
  return _.map(diffChanges, (diffChange) => {
    return {
      change: makeChange(diffChange.path, diffChange.prevValue, diffChange.value, prevState, state),
      data: makeData(namedParts, diffChange.wilds)
    };
  });

}

function compilePatternMatcher(pattern) {
  const wilds = pattern.match(WILD_REGEX);
  const namedParts = _.map(wilds, (wild) => {
    return wild
      .replace(CLOSING_CURLY_REGEX, '')
      .replace(OPENING_CURLY_REGEX, '');
  });

  const parts = pattern.split('.')
    .map((part) => {
      return part.replace(WILD_REGEX, '*');
    });

  return {
    parts,
    namedParts
  };
}

export default function handleChange(pattern, handler) {
  if (!_.isFunction(handler)) {
    return state => state;
  }
  const patternMatcher = compilePatternMatcher(pattern);
  return (state, change) => {
    const matches = matchPatternChanges(change, patternMatcher);

    if (_.isEmpty(matches)) {
      return state;
    }

    return _.reduce(matches, (nextState, match) => {
      return handler(nextState, match.change, match.data);
    }, state);
  };
}
